import { HttpResponse1532ob1hsse1y as HttpResponse } from './HttpResponse.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  Companion_getInstance16dzvgcii8pc4 as Companion_getInstance,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpResponseClass;
function DefaultHttpResponse() {
  if (DefaultHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, responseData) {
        super();
        this.s5y_1 = call;
        this.t5y_1 = responseData.y5j_1;
        this.u5y_1 = responseData.t5j_1;
        this.v5y_1 = responseData.w5j_1;
        this.w5y_1 = responseData.u5j_1;
        this.x5y_1 = responseData.z5j_1;
        var tmp = this;
        var tmp_0 = responseData.x5j_1;
        var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel()) ? tmp_0 : null;
        tmp.y5y_1 = tmp0_elvis_lhs == null ? Companion_getInstance().t4j_1 : tmp0_elvis_lhs;
        this.z5y_1 = responseData.v5j_1;
      }
      e5j() {
        return this.s5y_1;
      }
      sv() {
        return this.t5y_1;
      }
      n5j() {
        return this.u5y_1;
      }
      o5j() {
        return this.v5y_1;
      }
      p5j() {
        return this.w5y_1;
      }
      q5j() {
        return this.x5y_1;
      }
      m5j() {
        return this.y5y_1;
      }
      w50() {
        return this.z5y_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpResponse');
    DefaultHttpResponseClass = $;
  }
  return DefaultHttpResponseClass;
}
//region block: exports
export {
  DefaultHttpResponse as DefaultHttpResponse2wnrinzo0twhn,
};
//endregion

//# sourceMappingURL=DefaultHttpResponse.mjs.map
